<template>
	<div class="setup-screen message wysiwyg-content">
		<StarsBackdrop class="star-count" :star-count="20">
			<div class="title">Rotate Device</div>
			<div class="content">This game is best played in landscape mode
				on a tablet or phone.</div>
			<svg viewBox="0 0 67.73 123" xmlns="http://www.w3.org/2000/svg" v-bind:class="'phone'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M6.28 6h54v107h-54z" fill="#bd8043"/><path d="M67.69 111.59L67.6 102l-.17-19.27-.34-62.55L67 10.5V5.68c0-1.85 0-2.63-.55-3.59A4.15 4.15 0 0064.06.18a5 5 0 00-.75-.18 7.27 7.27 0 00-.9 0H60l-9.64.11-38.55.34L7 .5 4.59.52H3.41a4.76 4.76 0 00-.66.08A3.5 3.5 0 00.09 3.23a2.8 2.8 0 00-.09.64v1l.18 19.32.34 62.55L.69 106l.09 9.64v1.06a2.63 2.63 0 00.07.49 2.55 2.55 0 00.42.88 2.61 2.61 0 001.61 1 3.73 3.73 0 00.48 0h8.36l9.64-.08 19.27-.17c14.78-.08 22.17 2 22.17 4.16 0-.75 1.86-1 3.71-3.11a5 5 0 001.21-3.48zM20.63 9.25c.44-1.39 1.73-3.33 3.19-3.33h23.55l-1 2.16-26 1zM33.87 113a5 5 0 01-5-5c0-2.76 2.24-4 5-4a5 5 0 015 5c0 2.76-2.24 4-5 4zm26.41-14h-54V14h54z" fill="#e8e4b7"/></svg>
		</StarsBackdrop>
	</div>
</template>

<script>
import StarsBackdrop from '@/components/partials/StarsBackdrop';

export default {
	name: 'RestrictOrientation',
	components: {
		StarsBackdrop,
	},
};
</script>

<style lang="scss" scoped>
	.message {
		width: 100vw;
		height: 100vh;
		text-align: center;
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		transition: all $ui-transition-duration;
		z-index: $z-top + $z-top;

		//@include mobile { display: none; }
		//@include tablet { display: none; }
		@include mobile-restrict-orientation { display: none; }
		@include tablet-restrict-orientation { display: none; }
		@include desktop { display: none; }
	}

	.star-count {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		overflow-x: hidden;
		height: 100%;
		width: 100%;
		padding: 10%;
	}

	.title {
		font-family: $body-font;
		text-transform: uppercase;
		font-size: $heading-size-x-lg;
		color: $primary-color-light;
		z-index: $z-top;
		width: 8ch;
		line-height: 1;
		margin-bottom: 50px;
		letter-spacing: $letter-spacing-script;
		text-align: center;

		@include mobile-lg {
			font-size: $heading-size-base;
			margin-bottom: 20px;
		}
	}

	.content {
		font-family: $body-font-alt;
		font-size: $font-size-xx-lg;
		color: $off-white-dark;
		z-index: $z-top;
		margin-bottom: 50px;
		width: 20ch;

		@include mobile-lg {
			font-size: $font-size-base;
			margin-bottom: 5vh;
		}
	}

	.phone {
		position: relative;
		height: 35vh;
		z-index: $z-top;
		margin-bottom: 5vh;
	}
</style>



// WEBPACK FOOTER //
// src/components/base/RestrictOrientation.vue